import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ToastContext, useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

import { transformRequestEditOrderTrackingEmbed, transformResponseOrderTrackingEmbed } from './transformers'

const useEmbedSetup = ({ storeId, onSaved }) => {
  const { t } = useTranslation()
  const { setToastInfo } = useContext(ToastContext)
  const [allowedDomains, setAllowedDomains] = useState([])
  const [hideHeader, setHideHeader] = useState(false)

  const { data: orderTrackingEmbed, error: orderTrackingEmbedError } = useFetch(
    configurationServices.getOrderTrackingEmbed,
    {
      doInitialRequest: true,
      params: { storeId },
      transformResponse: transformResponseOrderTrackingEmbed,
    }
  )

  const { fetchData: editOrderTrackingEmbed, loading: savingOrderTrackingEmbed } = useFetch(
    configurationServices.editOrderTrackingEmbed,
    { doInitialRequest: false, transformRequest: transformRequestEditOrderTrackingEmbed }
  )

  useEffect(() => {
    if (!orderTrackingEmbed) return

    setAllowedDomains(orderTrackingEmbed.allowed_domains)
    setHideHeader(orderTrackingEmbed.hide_header)
  }, [orderTrackingEmbed])

  const gettingOrderTrackingEmbed = !orderTrackingEmbed && !orderTrackingEmbedError
  const canSave = allowedDomains.length > 0 && !savingOrderTrackingEmbed

  const handleChangeHideHeader = event => setHideHeader(event.target.checked)

  const handleSave = async () => {
    try {
      await editOrderTrackingEmbed({ storeId, embed: { allowed_domains: allowedDomains, hide_header: hideHeader } })
      setToastInfo({ show: true, message: t('Cambios guardados'), type: 'success' })
      onSaved()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    gettingOrderTrackingEmbed,
    allowedDomains,
    handleChangeAllowedDomains: setAllowedDomains,
    hideHeader,
    handleChangeHideHeader,
    canSave,
    savingOrderTrackingEmbed,
    handleSave,
  }
}

export default useEmbedSetup
